module.exports = __webpack_public_path__ + "img/login-bottom-min.212647cd.png";